import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from './Field.js';
import FieldError from './FieldError.js';
import FieldLabel from './FieldLabel.js';
import withForm$1 from '../../cinnamon-core/es/components/forms/withForm.js';
import FieldClearer$1 from '../../cinnamon-core/es/components/forms/FieldClearer.js';
import FieldTrigger$1 from '../../cinnamon-core/es/components/forms/FieldTrigger.js';
import FieldCondition$1 from '../../cinnamon-core/es/components/forms/FieldCondition.js';
import ErrorMessage from '../api/ErrorMessage.js';
import { createComponentSlot } from '../../modules/styling/theme.js';
import Input from './fields/Input.js';
import Numeric from './fields/Numeric.js';
import Email from './fields/Email.js';
import Password from './fields/Password.js';
import Checkbox from './fields/Checkbox.js';
import CheckboxGroup from './fields/CheckboxGroup.js';
import CheckboxTree from './fields/CheckboxTree.js';
import DateField from './fields/DateField.js';
import DateTime from './fields/DateTime.js';
import Dropdown from './fields/Dropdown.js';
import RadioGroup from './fields/RadioGroup.js';
import Rating from './fields/Rating.js';
import Switch from './fields/Switch.js';
import TextArea from './fields/TextArea.js';
import TimeField from './fields/TimeField.js';
import TypeAhead from './fields/TypeAhead.js';
import Url from './fields/Url.js';
import MonthField from './fields/Month.js';
import YearField from './fields/Year.js';
import GroupField from './collections/GroupField.js';
import CustomErrorsField from './collections/CustomErrorsField.js';
import ArrayAction from './collections/ArrayAction.js';
import ArrayField from './collections/ArrayField.js';
import ObjectField from './collections/ObjectField.js';
import ArrayAdder from './collections/ArrayAdder.js';
import ArrayRemover from './collections/ArrayRemover.js';
import ArrayTable from './collections/ArrayTable.js';
import { omitProps } from '../../cinnamon-core/es/components/forms/utils.js';

var _templateObject;
var componentRoot = createComponentSlot({
  name: "CinForm",
  slot: "Root"
});

var FormBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBase, _React$Component);

  var _super = _createSuper(FormBase);

  function FormBase() {
    var _this;

    _classCallCheck(this, FormBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      var onSubmit = _this.props.onSubmit;
      e.preventDefault();
      if (onSubmit) onSubmit(e);
    });

    return _this;
  }

  _createClass(FormBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          passThruProps = _this$props.passThruProps,
          error = _this$props.error,
          className = _this$props.className,
          children = _this$props.children;
      var otherProps = omitProps(passThruProps, Object.keys(FormBase.propTypes));
      return /*#__PURE__*/React.createElement("form", _extends({}, otherProps, {
        onSubmit: this.onSubmit,
        className: classnames(componentRoot.className, className)
      }), children, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      }));
    }
  }]);

  return FormBase;
}(React.Component);

_defineProperty(FormBase, "propTypes", {
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  onValidated: propTypes.any,
  onError: propTypes.any,
  errors: propTypes.any,
  onChange: propTypes.any.isRequired,
  value: propTypes.any,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  error: propTypes.any
});

_defineProperty(FormBase, "defaultProps", {
  value: {},
  showErrors: false,
  allErrors: false,
  animateErrors: 400,
  disabled: false,
  readOnly: false
});

var ConnectedForm = withForm$1({
  defaultProps: {
    animateErrors: 400
  }
})(FormBase);
var FormRoot = styled(ConnectedForm, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Wraps a collection of form fields, and manages data and validation state
 */

var Form = function Form(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(FormRoot, rootProps);
}; // bundle related sub-components

/** A container for a form field with an optional label and errors */


Form.Field = Field;
/** A button to clear or reset form fields when clicked */

Form.Clearer = FieldClearer$1;
/** Displays a collection of errors for a form field */

Form.Error = FieldError;
/** Displays a label for a form field */

Form.Label = FieldLabel;
/** A form listener to trigger actions upon field events */

Form.Trigger = FieldTrigger$1;
/** Conditionally render child components using the current form state */

Form.If = FieldCondition$1;
/** Field for a single line of text */

Form.Input = Input;
/** Field for a numeric value */

Form.Numeric = Numeric;
/** Field for an email address */

Form.Email = Email;
/** Field for a password */

Form.Password = Password;
/** Field for a single checkbox */

Form.Checkbox = Checkbox;
/** Field for a group of checkboxes */

Form.CheckboxGroup = CheckboxGroup;
/** Field for a tree-view of checkboxes */

Form.CheckboxTree = CheckboxTree;
/** Field for choosing a date */

Form.Date = DateField;
/** Field for choosing a date and time */

Form.DateTime = DateTime;
/** Field for a dropdown menu */

Form.Dropdown = Dropdown;
/** Field for a group of radio buttons */

Form.RadioGroup = RadioGroup;
/** Field for choosing a rating value */

Form.Rating = Rating;
/** Field for a toggle switch */

Form.Switch = Switch;
/** Field for multi-line text */

Form.TextArea = TextArea;
/** Field for choosing a time */

Form.Time = TimeField;
/** Field for a type-ahead search field */

Form.TypeAhead = TypeAhead;
/** Field for entering a URL */

Form.Url = Url;
/** Field for choosing a month */

Form.Month = MonthField;
/** Field for choosing a year */

Form.Year = YearField;
/** Groups form fields into columns */

Form.Group = GroupField;
/** Displays a collection of errors with custom validation handling */

Form.CustomErrors = CustomErrorsField;
/** A clickable action that can be performed on a row in an Array field */

Form.ArrayAction = ArrayAction;
/** Nests child form field data within an array of objects */

Form.Array = ArrayField;
/** Nests child form field data within an object */

Form.Object = ObjectField;
/** Button to append a new item into a form array */

Form.ArrayAdder = ArrayAdder;
/** Button to remove the current Array item. */

Form.ArrayRemover = ArrayRemover;
/** Combines a Form.Array and Table component, to enable form array data to be rendered as table rows */

Form.ArrayTable = ArrayTable;
var Form$1 = Form;

export { Form$1 as default };
